// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bd44593e","498":"e054e6c4","703":"68a94c10","787":"4dde9dbf"}[chunkId] + ".chunk.js";
};